import { cloneDeep } from 'lodash';
import React, { FC, useCallback, useEffect } from 'react';
import { DraggableWorksheetFormComponent, FormElementFile, WorksheetFormElementOption } from '@packages/models/api';
import { AddFieldType } from './worksheet-form-component-edit-modal';
import AddField from './add-field';
import { InputPickerHelper } from './inputPickers/input-picker-helper';
import colors from '@packages/core/styles/colors';
import { useValidationField } from './hooks/useValidationField';

interface FormWorksheetEditDateProps extends DraggableWorksheetFormComponent {
    onChange({
        formElementLabel,
        options,
        formElementFile,
        formElementDescription,
    }: {
        formElementLabel?: string;
        options?: WorksheetFormElementOption[] | undefined;
        worksheetElementTooltip?: string;
        formElementFile?: FormElementFile;
        formElementDescription?: string;
    }): void;
    addField: AddFieldType;
    setIsValid: React.Dispatch<React.SetStateAction<boolean>>;
}

export const FormEditDate: FC<FormWorksheetEditDateProps> = ({
    formElementLabel,
    formElementFile,
    options,
    onChange,
    addField,
    formElementTooltip,
    formElementDescription,
    setIsValid,
}) => {
    const {
        fieldHandlers: { handleRequired },
        fieldErrorMessages,
        isValid,
    } = useValidationField();
    useEffect(() => {
        setIsValid(isValid);
    }, [Object.keys(fieldErrorMessages || {})]);

    const handleDateChange = useCallback(
        (date: string) => {
            if (!options) {
                return;
            }
            const optionsClone = cloneDeep(options);
            optionsClone[0].optionLabel = date;
            onChange({ options: optionsClone });
        },
        [onChange, options]
    );

    return (
        <>
            <AddField
                addFieldValues={addField}
                onchangeText={onChange}
                formElementTooltip={formElementTooltip}
                formElementDescription={formElementDescription}
                formElementLabel={formElementLabel}
                formElementFile={formElementFile}
                errorMessage={fieldErrorMessages?.questionLabel}
                handleRequired={handleRequired}
            />
            <hr style={{ borderWidth: 2, borderColor: colors.grayTwo }} />
            <InputPickerHelper
                type="date"
                data={options?.[0].optionLabel || ''}
                onChange={(date) => handleDateChange(date)}
                iconName={'calendar'}
            />
        </>
    );
};
